import { Link } from 'gatsby';
import { default as React } from 'react';
import { Highlight, Index, Snippet, useHits } from 'react-instantsearch';
import LinkComponent from '../../utils/linkComponent';

const PageHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Page',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} tagName='mark' />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} tagName='mark' />
				</div>
			))}
		</>
	);
};
const EventHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Event',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} tagName='mark' />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} tagName='mark' />
				</div>
			))}
		</>
	);
};
const ResourceHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Resource',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} tagName='mark' />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} tagName='mark' />
				</div>
			))}
		</>
	);
};
const MemberHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'MemberHit',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} tagName='mark' />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} tagName='mark' />
				</div>
			))}
		</>
	);
};
const DiscourseHit = (props) => {
	const { hits } = useHits(props);
	console.log('Rendering DiscourseHit 2');
	console.log('Discourse hits:', hits);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.topic.url}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.topic?.title || null,
								link: hit.topic?.url || null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Discourse',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id || null,
								matchedwords:
									hit._highlightResult?.topic?.title?.matchedWords || null,
							});
							props.setFocus(false);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='topic.title' hit={hit} tagName='mark' />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} tagName='mark' />
				</div>
			))}
		</>
	);
};
const HitsInIndex = ({ index, setFocus }) => (
	<Index indexName={index.name}>
		<h5 style={{ color: 'var(--primary)' }}>{index.title}</h5>
		{/* <HitCount /> */}
		{index.name === 'Resources' ? (
			<ResourceHit className='Hits' setFocus={setFocus} />
		) : index.name === 'MembersDirectory' ? (
			<MemberHit className='Hits' setFocus={setFocus} />
		) : index.name === 'Pages' ? (
			<PageHit className='Hits' setFocus={setFocus} />
		) : index.name === 'Events' ? (
			<EventHit className='Hits' setFocus={setFocus} />
		) : index.name === 'discourse-posts' ? (
			<DiscourseHit className='Hits' setFocus={setFocus} />
		) : null}
	</Index>
);

const SearchResult = ({ indices, className, setFocus }) => (
	<div className={className}>
		{indices.map((index) => (
			<HitsInIndex index={index} key={index.name} setFocus={setFocus} />
		))}
	</div>
);
export default SearchResult;
